export default "__VITE_ASSET__bHDg5I3b__"